
import { map } from 'rxjs/operators';


import { Injectable } from '@angular/core';
import { reject } from 'q';

export const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
    })
};


//import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
//import { AngularFirestore } from 'angularfire2/firestore';

import { Observable } from 'rxjs/internal/Observable';
import { TaskQueue } from '../../core/_shared/models/task-queue.model';
import { Pager } from '../../core/_shared/pager';
import {  CURRENT_DATABASE } from '../../core/_shared/constants';
import { firstValueFrom, Observer } from 'rxjs';
import { Filter } from '../../core/_shared/models/filter.model';


import { DbCustomerLotteryFiltersParams } from './database/db-customer-lotery-filters-params';
import { DbCustomer } from './database/db-customer';
import { DbLottery } from './database/db-lottery';
import { DbTasksQueue } from './database/db-tasks-queue';
import { DbLotteries, DbTasks } from './database/db-lotteries';
import { DbLotteryDraws } from './database/db-lottery-drawns';
import { DbRecycles } from './database/db-recycles';
import { DatabaseManagerService } from './database-cast/database-manager.service';
import { ICollectionReference, IDocumentReference } from './database-cast/IDatabase';
import { DbCustomers } from './database/db-customers';
import { DbMethods } from './database/db-methods';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { UserService } from './user.service';
import { Bet } from '../../core/_shared/models/bet.model';
import { RelationalDatabase } from './database/Relational/relational-database';
import { DbSystems } from './database/db-systems';
import { WebApiService } from './WebApiService';
import { WebApiConnectionService } from "./database-cast/mongo/WebApiConnectionService";
import { BetItem } from '../_shared/bet-item.model';




@Injectable()
export class DatabaseService {
   



    getRealtionalDatabase(): RelationalDatabase {

        return new RelationalDatabase(this.http,this.webApi);
    }

    getUsers(): Promise<any> {

        return this.http.get(this.webApi.GetApiAddress() + `/Users/All`, httpOptions)
            .pipe(
                map(result => {

               
                    return result;

                }

                )).toPromise();
    }

    getRecycles(): DbRecycles {


        let recycles = new DbRecycles(this.databaseManager.get(CURRENT_DATABASE));

        return recycles;
    }


    collection(path: string): ICollectionReference {

        return this.databaseManager.get(CURRENT_DATABASE).collection(path);
    }



    public getLotteryDraws(): DbLotteryDraws {
        return new DbLotteryDraws(this.databaseManager.get(CURRENT_DATABASE).collection("lottery-drawns"));
    }


    public getCustomers() {
        return new DbCustomers(this.databaseManager.get(CURRENT_DATABASE).collection("lottolocos"));
    }


    getSystem() {
        return new DbSystems(this.databaseManager.get(CURRENT_DATABASE).collection("systems"));
    }


    public getMethods() {
        return new DbMethods(this.databaseManager.get(CURRENT_DATABASE).collection("methods"));
    }


    public getTaskQueue(): DbTasksQueue {
        return new DbTasksQueue(this.databaseManager.get(CURRENT_DATABASE).collection("TasksQueue"));
    }

    getLottery(lotteryId: string): DbLottery {

        let lottery = new DbLottery(lotteryId, this.databaseManager.get(CURRENT_DATABASE)
            .collection(`config-lotteries`));

        return lottery;
    }

    public getLotteries(): DbLotteries {
        let lotteries = new DbLotteries(this.databaseManager.get(CURRENT_DATABASE));


        return lotteries;
    }


    public getTasks(): DbTasks {
        let tasks = new DbTasks(this.databaseManager.get(CURRENT_DATABASE));

        return tasks;
    }



    public getCurrentCustomer(): DbCustomer {


        let userId = this.auth.getCurrentUserId();

        let customer = new DbCustomer(userId, this.databaseManager.get(CURRENT_DATABASE)
            .collection(`lottolocos`));

        return customer;
    }



    cursor: any;
    constructor(private auth: UserService, private http: HttpClient,private httpMong: WebApiConnectionService,private webApi:WebApiService, private databaseManager: DatabaseManagerService) {

    }

    public getBets(lotteryModeId: string): Promise<Bet[]> {

        let userId = this.auth.getCurrentUserId();


        let promise: Promise<Bet[]> = new Promise((resolve, reject) => {

            this.databaseManager.get(CURRENT_DATABASE)
                .collection(`/lottolocos/${userId}/lotteries/${lotteryModeId}/bets/`).orderBy("BetDate", "desc")
                .limit(30)
                .get()
                .then((querySnapshot: any) => {

                    let bets: Array<any> = [];
                    querySnapshot.forEach(doc => {
                        let bet = doc.data();

                        bets.push(bet);
                    });


                    resolve(bets);

                })
                .catch(error => {
                    reject(error);
                });


        });


        return promise;
    }


    public addTaskQueue(taskQueue: TaskQueue): Promise<TaskQueue> {

        let promise = new Promise<TaskQueue>((resolve, reject) => {
            let userId = this.auth.getCurrentUserId();

            //  taskQueue.Email = email;//Corrigir
            taskQueue.UserId = userId;

            this.databaseManager.get(CURRENT_DATABASE).collection(`tasks`)
                .add((Object.assign({}, taskQueue)))
                .then((result) => {
                    taskQueue.id = result.id;
                    resolve(taskQueue);
                }).catch(error => {
                    reject(error);
                });

        });


        return promise;
    }

    updateBet(bet: Bet, lotteryModeId: string): Promise<any> {

        let userId = this.auth.getCurrentUserId();
        return this.databaseManager.get(CURRENT_DATABASE)
            .collection("lottolocos").doc(userId)
            .collection("lotteries").doc(lotteryModeId)
            .collection("bets").doc(bet.id.toString())
            .set(Object.assign({}, bet));

    }


    deleteBet(id: string, lotteryModeId: string): Promise<any> {

   
        let userId = this.auth.getCurrentUserId();
        return this.databaseManager.get(CURRENT_DATABASE)
            .collection("lottolocos").doc(userId)
            .collection("lotteries").doc(lotteryModeId)
            .collection("bets").doc(id)
            .delete();
    }


    public addBet(bet: Bet, lotteryModeId: string): Promise<any> {

        console.log("//addBet Adiciona uma bet nova");
         console.log("//Preciso descobrir como isso funciona");

        let promise: Promise<any> = new Promise((resolve, reject) => {
            let userId = this.auth.getCurrentUserId();

            let tasks = bet.Tasks;
            delete bet.Tasks;

            if (bet.id == null || bet.id == "") {
                let id = new Date().getTime().toString();
                bet.id = id;

                console.log("Criou um novo Bet Id: " + bet.id);
            }
            else
            {
                console.log("Não precisou recriar o  Bet Id: " + bet.id);
            }


            // delete tasks[0].id;

            this.databaseManager.get(CURRENT_DATABASE)
                .collection("lottolocos").doc(userId)
                .collection("lotteries").doc(lotteryModeId)
                .collection("bets").doc(bet.id)
                .set(Object.assign({}, bet))
                .then(() => {

                    this.getCurrentCustomer()
                        .getLottery(lotteryModeId)
                        .updateFields({ lastModified: new Date() })
                        .then();


                    this.databaseManager.get(CURRENT_DATABASE)
                        .collection("lottolocos").doc(userId)
                        .collection("lotteries").doc(lotteryModeId)
                        .collection("bets").doc(bet.id)
                        .collection("tasks")
                        .doc(tasks[0].id)
                        .set(tasks[0])
                        .then((result) => {

                            bet.Tasks = tasks;

                            resolve(bet);
                        })


                }).catch((error) => {

                    reject(error);
                });


        }
        );

        return promise;

    }

    deleteBets(bet: Bet, lotteryId: string, start: number, end: number, options: boolean[]): Promise<any[]> {
        let userId = this.auth.getCurrentUserId();

        let path = `SolutionBet/delete/${userId}/${lotteryId}/${bet.id}`;
        //
        let deleteDataModel = { start: start, end: end, options: options };

        let body = JSON.stringify(deleteDataModel);


        // let requestOptions = new RequestOptions({ method: RequestMethod.Post });

        // requestOptions.headers = new Headers({ 'Content-Type': 'application/json' });
        //  requestOptions.headers = new Headers({ 'Content-Type': 'application/json' })

        return this.http.post(this.webApi.GetApiAddress() + '/' + path, body, httpOptions).pipe(
            map(data => {

                return data;
            }))
            .toPromise()
            .then((result: any[]) => {

                return result;
            })


    }

    updateCustomerLotteryFilterParams(lotteryId: string, filterParams: any[]): Promise<any> {
        let userId = this.auth.getCurrentUserId();



        return this.databaseManager.get(CURRENT_DATABASE)
            .collection("lottolocos").doc(userId)
            .collection("lotteries").doc(lotteryId)
            .collection("filters").doc("params")
            .set(Object.assign({}, filterParams))
            .then(() => {
                
            })

    }

    getFilterTypes(): Promise<any[]> {



        return this.http.get(this.webApi.GetApiAddress() + '/' + "filters/types", httpOptions).pipe(
            map((data: any[]) => {
                console.log(data);
                return data;
            }))
            .toPromise();


    }
public async getBetSolution(bet: Bet, lotteryId: string, pager: Pager): Promise<BetItem[]> {
    const userId = this.auth.getCurrentUserId();

    const timeout = new Promise<BetItem[]>((_, reject) => 
        setTimeout(() => reject("Timeout: Response not received in 3 seconds"), 3000)
    );

    try {
        // Promessa do HTTP
        const signalRCall = firstValueFrom(
            this.httpMong.getBetItemsFromFile(
                bet.MachineId,
                userId,
                lotteryId,
                bet.id,
                bet.solutionFileName,
                pager.newPageIndex,
                pager.length,
                pager.skip
            )
        );

        // Aguarda o mais rápido: resposta ou timeout
        const result = await Promise.race([signalRCall, timeout]);

        if(result.length === 0) {
            throw new Error("Nenhum item encontrado na solução da aposta.");
            debugger;
        // Atualiza paginação
        }
        
        
        pager.currentPageIndex = pager.newPageIndex;

        return result as BetItem[];

    } catch (error) {
        // Pode logar se quiser:
         console.error("Erro ou timeout ao obter os itens da aposta:", error);
        return [];
    }
}


    prepareBetToDownload(bet: Bet, lotteryId: string, pager: Pager): Observable<any> {
        let userId = this.auth.getCurrentUserId();
    
       
        // Conversão do Observable para Promise
       return this.httpMong.prepareBetToDownload(bet.MachineId, userId, lotteryId, bet.id,bet.solutionFileName);

    

    }
    public getBetDoc(key: string, lotteryModeId: string): IDocumentReference {

        let userId = this.auth.getCurrentUserId();
        return this.databaseManager.get(CURRENT_DATABASE)
            .collection("lottolocos").doc(userId)
            .collection("lotteries").doc(lotteryModeId)
            .collection("bets").doc(key);


    }


    public getBet2(key: string, lotteryModeId: string): IDocumentReference {

        let userId = this.auth.getCurrentUserId();

        return this.databaseManager.get(CURRENT_DATABASE)
            .collection("lottolocos").doc(userId)
            .collection("lotteries").doc(lotteryModeId)
            .collection("bets").doc(key)


    }

    public getFilter(filterId: number, lotteryId: string): Promise<Filter> {

        //  let email = this.auth.getCurrentUserId();

        let promise: Promise<Filter> = new Promise((resolve, reject) => {

            this.databaseManager.get(CURRENT_DATABASE)
                .collection(`/config-lotteries/${lotteryId}/filters/`)
                .doc(filterId.toString())
                .get()
                .then((snapshot) => {

                    let filter = Object.assign(snapshot.data());

                    resolve(filter);
                })
                .catch(error => {
                    reject(error);
                });

        });


        return promise;

    }

    public getFilters(lotteryId: string): Promise<Filter[]> {

        //   let userId = this.auth.getCurrentUserId();


        let promise: Promise<Filter[]> = new Promise((resolve, reject) => {

            this.databaseManager.get(CURRENT_DATABASE)
                .collection(`/config-lotteries/${lotteryId}/filters/`).orderBy("id", "desc")
                .limit(30)
                .get()
                .then((querySnapshot: any) => {

                    let filters: Array<Filter> = [];
                    querySnapshot.forEach(doc => {
                        let filter = doc.data();
                        filter.id = doc.id;
                        filters.push(filter);
                    });


                    resolve(filters);

                })
                .catch(error => {
                    reject(error);
                });


        });


        return promise;
    }

    public addFilter(filter: Filter, lotteryId: string): Promise<any> {

        let promise: Promise<any> = new Promise((resolve, reject) => {


            let id = new Date().getTime().toString();
            filter.id = id;



            this.databaseManager.get(CURRENT_DATABASE)
                .collection("config-lotteries").doc(lotteryId)
                .collection("filters").doc(id)
                .set(Object.assign({}, filter))
                .then(() => {


                    resolve(filter);


                }).catch((error) => {
                    console.log(error);
                    reject(error);
                });


        }
        );

        return promise;

    }


    public updateFilter(filter: Filter, lotteryModeId: string): Promise<any> {


        console.log(filter);

        if (filter.data == null) {
            filter.data = "";
        }
        let promise = new Promise<Filter>((resolve) => {
            this.databaseManager.get(CURRENT_DATABASE)
                .collection(`/config-lotteries/${filter.lotteryId}/filters/`)
                .doc(filter.id)
                .set(Object.assign({}, filter))
                .then(() => {
                    resolve(filter);
                });
        });

        return promise;


    }

    public deleteFilter(id: string, lotteryId: string): Promise<any> {

        console.log(`/config-lotteries/${lotteryId}/filters/${id}`);

        return this.databaseManager.get(CURRENT_DATABASE)
            .collection(`/config-lotteries/${lotteryId}/filters`)
            .doc(id)
            .delete().catch(error => {
                console.log("Erro");
                console.log(error);
            });
    }


}